// src/App.js (or your path)

import React, { useState, useEffect } from "react";
import Preloader from "./components/utils/Preloader";
import Navbar from "./components/layout/Navbar";
import Home from "./screens/Home/Home";
import Projects from "./screens/Projects/Projects";
import DWML from "./screens/Delos/DWML";
import DS from "./screens/DataScience/DS";
import DA from "./screens/DataAnalytics/DA";
import Midas from "./screens/Midas/Midas";
import Orwell from "./screens/Orwell/Orwell";
import CovidPredictor from "./screens/Covid19/covid_predictor";
import SensorCharting from "./screens/SensorDP/SensorCharting";
import PrivacyPolicy from "./screens/Privacy/privacypolicy";
import Chat from "./screens/Chat/Chat";
import Hermes from "./screens/Hermes/Hermes";
import Footer from "./components/layout/Footer";
import { Prometheus } from "./screens/Prometheus/Prometheus";
import {
  BrowserRouter as Router, // Keep BrowserRouter as Router alias
  Route,
  Routes,
  Navigate,
  // useLocation // No need to import useLocation here, it will be in Toaster.tsx
} from "react-router-dom";
import { usePostHog } from 'posthog-js/react';

// REMOVE React-Toastify imports if no other component uses them
// import { ToastContainer } from 'react-toastify';
// import 'react-toastify/dist/ReactToastify.css';

import { Toaster } from "@/components/ui/toaster"; // Your shadcn Toaster

import ScrollToTop from "./components/utils/ScrollToTop";
import "./style.css";
import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";

function App() {
  const [load, upadateLoad] = useState(true);
  const posthog = usePostHog();

  useEffect(() => {
    const timer = setTimeout(() => {
      upadateLoad(false);
    }, 1200);

    return () => clearTimeout(timer);
  }, []);

  return (
    <Router> {/* BrowserRouter is aliased as Router */}
      {/* REMOVE React-Toastify's ToastContainer */}
      {/* <ToastContainer /> */}
      <Preloader load={load} />
      <div className="App" id={load ? "no-scroll" : "scroll"}>
        <Navbar posthog={posthog} />
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/Projects" element={<Projects />} />
          <Route path="/Delos" element={<DWML />} />
          <Route path="/DataScience" element={<DS />} />
          <Route path="/DataAnalytics" element={<DA />} />
          <Route path="/Chat" element={<Chat />} />
          <Route path="/Midas" element={<Midas />} />
          <Route path="/Orwell" element={<Orwell />} />
          <Route path="/Prometheus" element={<Prometheus />} />
          <Route path="/Covid19" element={<CovidPredictor />} />
          <Route path="/SensorData" element={<SensorCharting />} />
          <Route path="/PrivacyPolicy" element={<PrivacyPolicy />} />
          <Route path="/Hermes" element={<Hermes />} />
          <Route path="*" element={<Navigate to="/" />} />
        </Routes>
        <Footer />
      </div>
      <Toaster /> {/* This is correctly placed */}
    </Router>
  );
}

export default App;